const Interno = () => import('@/domains/carteira/shared/layouts/Interno')
const Carteira = () => import('@/domains/carteira/views/Inicio')
const routes = [
    {
        path: '',
        component: Interno,
        children: [
            {
                name: 'carteira',
                path: '/carteira',
                alias: ['/carteira/inicio', '/carteira/sistema/inicio'],
                component: Carteira,
            }
        ]
    },
]
export default routes